/** ASCII / thin arrows / prior normalizations → **➜** (U+279C heavy round-tipped right arrow). */
const ROUTE_LABEL_ARROW_SOURCE_RE = /\s*(?:->|→|=>|↗|⬈|⇗|➜)\s*/g

const ROUTE_LABEL_SEPARATOR = ' \u279C '

/**
 * Normalize route-style labels for charts, tooltips, and table cells.
 * Idempotent when already using ➜.
 */
export const withUnicodeRouteArrow = (value: string): string =>
  value.replace(ROUTE_LABEL_ARROW_SOURCE_RE, ROUTE_LABEL_SEPARATOR)
